import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import {Button, Grid} from '@mui/material';
import React, {useEffect} from 'react';
import {Range} from 'react-range';
import {ISlider} from './ISlider';
import './slider.css';
import {Direction} from 'react-range';

export default function CustomisedSlider({
    minAmount,
    maxAmount,
    amountStep,
    defaultValue,
    setLoanAmount,
    enableMode,
    selectedLoanTemplateDetailItem,
    selectedLoanAmount,
}: ISlider) {
    const [sliderValue, setSliderValue] = React.useState(defaultValue);

    useEffect(() => {
        if (enableMode === false) {
            setSliderValue(0);
        }
    }, [enableMode]);

    useEffect(() => {
        if (enableMode === true && selectedLoanAmount === undefined) {
            setSliderValue(defaultValue);
        }
    }, [defaultValue]);

    useEffect(() => {
        if (selectedLoanAmount !== undefined) {
            setSliderValue(selectedLoanAmount);
        }
    }, [selectedLoanAmount]);

    useEffect(() => {
        if (
            enableMode === true &&
            selectedLoanTemplateDetailItem != null &&
            selectedLoanTemplateDetailItem != undefined &&
            selectedLoanAmount === undefined
        ) {
            setSliderValue(defaultValue);
        }
    }, [selectedLoanTemplateDetailItem]);
    const handleChange = (newValue: number[]) => {
        let selectedValue = newValue[0];

        if (selectedValue >= defaultValue) {
            setSliderValue(selectedValue);
        }
    };
    // add btn for slider
    const handleIncrement = () => {
        setSliderValue((prevValue) => {
            const newValue = prevValue + amountStep!;
            const updatedValue = newValue > maxAmount ? maxAmount : newValue;

            setLoanAmount(updatedValue);
            return updatedValue;
        });
    };

    const handleDecrement = () => {
        setSliderValue((prevValue) => {
            const newValue = prevValue - amountStep!;
            const updatedValue =
                newValue < defaultValue ? defaultValue : newValue;

            setLoanAmount(updatedValue);
            return updatedValue;
        });
    };

    return (
        <>
            <div style={{paddingBottom: '10px'}}>
                <Grid container>
                    <Grid item xs={6}>
                        <span
                            className="text-sm font-normal primaryColorLight-900 anjomanRegular"
                            style={{fontSize: '14px'}}
                        >
                            {'مبلغ تسهیلات'}
                        </span>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        style={{alignContent: 'center', paddingLeft: '5px'}}
                    >
                        <div
                            className="secondaryColorLight"
                            style={{
                                textAlign: 'end',
                                paddingTop: '0px',
                                paddingBottom: '0px',
                            }}
                        >
                            <span
                                className="text-sm font-bold"
                                style={{fontSize: '1em', fontWeight: 'bold'}}
                            >
                                {sliderValue?.toLocaleString('fa')}
                            </span>
                            <span
                                style={{fontSize: '0.6em', fontWeight: 'bold'}}
                            >
                                {' '}
                                ریال{' '}
                            </span>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <div
                dir="ltr"
                style={{
                    border: '1.5px solid var(--border-color)',
                    background: 'var(--input-bg-color)',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '15px',
                    borderRadius: '5px',
                }}
            >
                <Button
                    disableRipple
                    disableFocusRipple
                    disabled={!enableMode}
                    sx={{
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        padding: '0px',
                        minWidth: 'unset',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                    }}
                >
                    <AddCircleIcon
                        onClick={handleIncrement}
                        sx={{color: '#BBA57A', fontSize: '32px'}}
                    />
                </Button>

                <div style={{width: '100%', marginInline: '15px'}}>
                    <Range
                        disabled={!enableMode}
                        step={amountStep}
                        min={minAmount}
                        max={maxAmount}
                        values={[sliderValue]}
                        onChange={(values) => handleChange(values)}
                        onFinalChange={(values) => setLoanAmount(values[0])}
                        draggableTrack={true}
                        direction={Direction.Left}
                        renderTrack={({props, children}) => {
                            const percentage =
                                ((sliderValue - minAmount) /
                                    (maxAmount - minAmount)) *
                                100;
                            return (
                                <div
                                    {...props}
                                    style={{
                                        height: '3px',
                                        background: `linear-gradient(to left, #BBA57A ${percentage}%, #D7DBEC ${percentage}%)`,
                                        width: '100%',
                                        borderRadius: '3px',
                                    }}
                                >
                                    {children}
                                </div>
                            );
                        }}
                        renderThumb={({props}) => (
                            <div
                                {...props}
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    background: '#BBA57A',
                                    borderRadius: '50%',
                                }}
                            />
                        )}
                    />
                </div>
                <Button
                    disableRipple
                    disableFocusRipple
                    disableElevation
                    disabled={!enableMode}
                    sx={{
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        padding: '0px',
                        minWidth: 'unset',
                        '&:hover': {backgroundColor: 'transparent'},
                    }}
                >
                    <RemoveCircleIcon
                        onClick={handleDecrement}
                        sx={{color: '#BBA57A', fontSize: '32px'}}
                    />
                </Button>
            </div>
        </>
    );
}
